import { render } from "./ResetPasswordCard.vue?vue&type=template&id=0bc5cd82"
import script from "./ResetPasswordCard.vue?vue&type=script&lang=js"
export * from "./ResetPasswordCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__